// Central data-testid keys used across the app for stable e2e selectors.
export const NAV = {
  logo: "brand-logo",
  home: "nav-home",
  pricing: "nav-pricing",
  locations: "nav-locations",
  features: "nav-features",
  about: "nav-about",
  faq: "nav-faq",
  kb: "nav-kb",
  contact: "nav-contact",
  status: "nav-status",
  login: "nav-login",
  register: "nav-register",
  themeToggle: "theme-toggle",
  mobileMenu: "mobile-menu-toggle",
};

export const AUTH = {
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  nameInput: "auth-name-input",
  submit: "auth-submit-button",
  googleBtn: "auth-google-button",
  forgotLink: "auth-forgot-link",
  registerLink: "auth-register-link",
  loginLink: "auth-login-link",
  error: "auth-error-message",
};

export const PORTAL = {
  sidebar: "portal-sidebar",
  logout: "portal-logout-button",
  dashboard: "portal-dashboard",
  vpsList: "portal-vps-list",
  createVpsBtn: "portal-create-vps",
  ordersList: "portal-orders",
  invoicesList: "portal-invoices",
  walletBalance: "portal-wallet-balance",
  ticketsList: "portal-tickets",
  createTicketBtn: "portal-create-ticket",
};

export const ADMIN = {
  sidebar: "admin-sidebar",
  dashboard: "admin-dashboard",
  customers: "admin-customers",
  servers: "admin-servers",
  nodes: "admin-nodes",
  ippools: "admin-ippools",
  plans: "admin-plans",
  orders: "admin-orders",
  invoices: "admin-invoices",
  wallet: "admin-wallet",
  tickets: "admin-tickets",
  settings: "admin-settings",
  integrations: "admin-integrations",
};
